import {defineMessages} from "react-intl";

export default defineMessages({
  lorum_ipsum: {
    id: "lorum_ipsum",
    defaultMessage:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas mollis vitae ex a efficitur. Suspendisse nibh lectus, pretium ac arcu quis, maximus eleifend enim. In cursus hendrerit placerat. Curabitur faucibus risus ornare orci dignissim, vel aliquam dui molestie. Praesent non euismod lectus, in iaculis sapien. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Maecenas luctus velit at ante ullamcorper varius. Donec a orci feugiat, rhoncus nisl id, eleifend augue.",
  },
  combination_not_implemented: {
    id: "combination_not_implemented",
    defaultMessage:
      "Styling combination is not implemented yet and might break!",
  },
  can_not_update_without_pk: {
    id: `can_not_update_without_pk`,
    defaultMessage: `Can not update without pk`,
  },
  not_a_valid_api_key: {
    id: `not_a_valid_api_key`,
    defaultMessage: `Not a valid api key`,
  },
  model_not_valid: {
    id: `model_not_valid`,
    defaultMessage: `Model not valid`,
  },
  email_not_valid: {
    id: `email_not_valid`,
    defaultMessage: `This is not a valid email`,
  },
  not_found_page: {
    id: `not_found_page`,
    defaultMessage: `This page could not be found`,
  },
  search_message: {
    id: `search_message`,
    defaultMessage: "Search for patient ID, case no., etc..",
  },
  search_practice_message: {
    id: `search_practice_message`,
    defaultMessage: "Search for message...",
  },
  search_message_allowable_driver: {
    id: `search_message_allowable_driver`,
    defaultMessage: "Search for an driver...",
  },
  search_message_dentist: {
    id: `search_message_dentist`,
    defaultMessage: "Search for dentist name, ID...",
  },
  search_message_user: {
    id: `search_message_user`,
    defaultMessage: "Search for an user...",
  },
  search_message_practice: {
    id: `search_message_practice`,
    defaultMessage: "Search for a practice...",
  },

  search_messages: {
    id: `search_messages`,
    defaultMessage: "Search message...",
  },
  appointment_overview: {
    id: "appointment_overview",
    defaultMessage: "Appointment Overview",
  },
  appoint: {
    id: "appoint",
    defaultMessage: "Appointment",
  },
  phoneNumberReFrezh: {
    id: "phoneNumberRefrezh",
    defaultMessage: "088 - 700 5588",
  },
  dots: {
    id: "dots",
    defaultMessage: "...",
  },
  login: {
    id: `login`,
    defaultMessage: `Login`,
  },
  password: {
    id: `password`,
    defaultMessage: `Password`,
  },
  are_you_sure_you_want_to_go_back: {
    id: `are_you_sure_you_want_to_go_back`,
    defaultMessage: `Are you sure you want to go back?`,
  },
  go_back_to_dashboard: {
    id: "go_back_to_dashboard",
    defaultMessage: "Go back to dashboard",
  },
  deleted: {
    id: `deleted`,
    defaultMessage: `deleted`,
  },
  add_new_patient: {
    id: "addNewpatient",
    defaultMessage: "Add new patient",
  },
  addNewDentist: {
    id: "addNewDentist",
    defaultMessage: "Add new dentist",
  },
  new_treatment_case_number: {
    id: "new_treatment_case_number",
    defaultMessage: "Refrezh Case no: ",
  },
  practice_tag: {
    id: "practice_tag",
    defaultMessage: "Practice tag",
  },
  first_name_not_valid: {
    id: `first_name_not_valid`,
    defaultMessage: `First name not valid, minimal 2 characters`,
  },
  can_not_update: {
    id: `can_not_update`,
    defaultMessage: `Can not update`,
  },
  unauthorized: {
    id: `unauthorized`,
    defaultMessage: `Unauthorized`,
  },
  user_id_not_valid: {
    id: `user_id_not_valid`,
    defaultMessage: `User id is not valid`,
  },
  last_name_not_valid: {
    id: `last_name_not_valid`,
    defaultMessage: `Last name not valid, minimal 2 characters`,
  },
  invalid_session: {
    id: `invalid_session`,
    defaultMessage: `invalid session`,
  },
  remember_me: {
    id: `remember_me`,
    defaultMessage: `Remember me`,
  },
  not_found: {
    id: `not_found`,
    defaultMessage: `Not found`,
  },
  internal_ref: {
    id: `internal_ref`,
    defaultMessage: `Internal ref.`,
  },

  topic: {
    id: `topic`,
    defaultMessage: `Topic`,
  },
  internal_ref_colon: {
    id: `internal_ref_colon`,
    defaultMessage: `Internal ref.:`,
  },
  incorrect_login: {
    id: `incorrect_login`,
    defaultMessage: `Username and/or password incorrect.`,
  },
  ok: {
    id: `ok`,
    defaultMessage: `ok`,
  },
  role_type_not_valid: {
    id: `role_type_not_valid`,
    defaultMessage: `Role type not valid`,
  },
  role_name_not_valid: {
    id: `role_name_not_valid`,
    defaultMessage: `Role name not valid, minimal 3 characters`,
  },
  email_already_registered: {
    id: `email_already_registered`,
    defaultMessage: `Email already registered`,
  },
  not_a_valid_role_type: {
    id: `not_a_valid_role_type`,
    defaultMessage: `Not a valid role type`,
  },
  forgot_password: {
    id: `forgot_password`,
    defaultMessage: `Forgot password`,
  },
  change_password: {
    id: `change_password`,
    defaultMessage: `Change password`,
  },
  username: {
    id: `username`,
    defaultMessage: `Username`,
  },
  register: {
    id: `register`,
    defaultMessage: `Register`,
  },
  passwordConfirm: {
    id: "passwordConfirm",
    defaultMessage: "Confirm password",
  },
  email: {
    id: "email",
    defaultMessage: "Email:",
  },
  emailNoColon: {
    id: "emailNoColon",
    defaultMessage: "Email",
  },
  first_name: {
    id: "first_name",
    defaultMessage: "Name:",
  },
  last_name: {
    id: "last_name",
    defaultMessage: "Last name:",
  },
  confirm: {
    id: "confirm",
    defaultMessage: "confirm",
  },
  back: {
    id: "back",
    defaultMessage: "Back",
  },
  passwordsDontMatch: {
    id: "passwordDontMatch",
    defaultMessage: "Your passwords don't match",
  },
  change: {
    id: "change",
    defaultMessage: "change",
  },
  logout: {
    id: "logout",
    defaultMessage: "Logout",
  },
  phoneNumber: {
    id: "phoneNumber",
    defaultMessage: "Phone number",
  },
  emergencyPhoneNumber: {
    id: "emergencyPhoneNumber",
    defaultMessage: "Emergency phone number",
  },
  emergencyPhoneNumberShort: {
    id: "emergencyPhoneNumberShort",
    defaultMessage: "Emergency phone nr.:",
  },
  role: {
    id: "role",
    defaultMessage: "Role",
  },
  phoneNumberShort: {
    id: "phoneNumberShort",
    defaultMessage: "Phone nr.:",
  },
  patientId: {
    id: "patientId",
    defaultMessage: "Patient ID.",
  },
  dentistId: {
    id: "dentistId",
    defaultMessage: "Dentist ID.",
  },
  dentist: {
    id: "dentist",
    defaultMessage: "Dentist",
  },
  dentistColon: {
    id: "dentistColon",
    defaultMessage: "Dentist: ",
  },
  caseNr: {
    id: "caseNr",
    defaultMessage: "Case no.",
  },
  caseNrColon: {
    id: "caseNrColon",
    defaultMessage: "Case no.:",
  },
  date: {
    id: "date",
    defaultMessage: "Date",
  },
  eta: {
    id: "eta",
    defaultMessage: "ETA",
  },
  cancel: {
    id: "cancel",
    defaultMessage: "Cancel",
  },
  save: {
    id: "save",
    defaultMessage: "Save",
  },
  not_save: {
    id: "not_save",
    defaultMessage: "Do not save",
  },
  delete: {
    id: "delete",
    defaultMessage: "Delete",
  },
  new: {
    id: "new",
    defaultMessage: "New",
  },
  users: {
    id: "users",
    defaultMessage: "Users",
  },
  privacy: {
    id: "privacy",
    defaultMessage: "Privacy policy",
  },
  terms_and_condition: {
    id: "termsAndCondition",
    defaultMessage: "Terms and Conditions",
  },
  terms_and_condition_description_part_1: {
    id: "termsAndConditionDescriptionPart1",
    defaultMessage: `By logging in to the ReFrezh Dashboard, you agree to the `,
  },
  terms_and_condition_description_part_2: {
    id: "termsAndConditionDescriptionPart2",
    defaultMessage: `and`,
  },
  terms_and_condition_description_part_3: {
    id: "termsAndConditionDescriptionPart3",
    defaultMessage: `that applies.`,
  },
  thanks_for_your_planned_appointment: {
    id: "thanksForYourPlannedAppointment",
    defaultMessage: "Thank you for your planned appointment!",
  },
  thanksForEditingAppointment: {
    id: "thanksForEditingAppointment",
    defaultMessage: "Thanks for editing",
  },
  name: {
    id: "name",
    defaultMessage: "name",
  },
  search: {
    id: "search",
    defaultMessage: "Search...",
  },
  no_username: {
    id: "noUsername",
    defaultMessage: "No username has been entered.",
  },
  no_search_results: {
    id: "noSearchResults",
    defaultMessage: "No results found",
  },
  extra_options: {
    id: "extra_options",
    defaultMessage: "Extra options",
  },
  planned_appointments: {
    id: "plannedAppointments",
    defaultMessage: "Planned Appointments",
  },
  patient_overview: {
    id: "patientOverview",
    defaultMessage: "Patient Overview",
  },
  patient_overview_large: {
    id: "patientOverviewLarge",
    defaultMessage: "Patients",
  },

  dentist_overview: {
    id: "dentistOverview",
    defaultMessage: "Dentist Overview",
  },
  dentist_overview_large: {
    id: "dentistOverviewLarge",
    defaultMessage: "Dentists",
  },
  appointments_overview_large: {
    id: "appointments_overview_large",
    defaultMessage: "Appointments",
  },
  practiceName: {
    id: "practiceName",
    defaultMessage: "Practice name",
  },
  practiceName_colon: {
    id: "practiceName_colon",
    defaultMessage: "Practice name:",
  },
  practitioner: {
    id: "practitioner",
    defaultMessage: "practitioner",
  },
  descriptionOptional: {
    id: "descriptionOptional",
    defaultMessage: "Description (optional)",
  },
  next: {
    id: "next",
    defaultMessage: "Next",
  },
  previous: {
    id: "previous",
    defaultMessage: "Previous",
  },
  other: {
    id: "other",
    defaultMessage: "other",
  },
  houseNr: {
    id: "houseNr",
    defaultMessage: "house number",
  },
  houseNrShort: {
    id: "houseNrShort",
    defaultMessage: "House nr.:",
  },
  houseNrAddendum: {
    id: "houseNrAddendum",
    defaultMessage: "addendum",
  },
  houseNrAddendumShort: {
    id: "houseNrAddendumShort",
    defaultMessage: "Add.:",
  },
  zipcode: {
    id: "zipcode",
    defaultMessage: "Zipcode:",
  },
  zipcodeNoColon: {
    id: "zipcodeNoColon",
    defaultMessage: "Zipcode",
  },
  city: {
    id: "city",
    defaultMessage: "City:",
  },
  cityNoColon: {
    id: "cityNoColon",
    defaultMessage: "City",
  },
  comments: {
    id: "comments",
    defaultMessage: "Comments",
  },
  state: {
    id: "state",
    defaultMessage: "State:",
  },
  isoCountry: {
    id: "isoCountry",
    defaultMessage: "Country code",
  },
  street: {
    id: "street",
    defaultMessage: "Street:",
  },
  streetNoColon: {
    id: "streetNoColon",
    defaultMessage: "Street",
  },
  continue: {
    id: "continue",
    defaultMessage: "continue",
  },
  schedule_the_follow_up_appointment: {
    id: "schedule_the_follow_up_appointment",
    defaultMessage: "Schedule the follow-up appointment",
  },
  treatment_result_header: {
    id: "treatment_result_header",
    defaultMessage: "ReFrezh KPT member comes over to treat",
  },
  hoursFull: {
    id: "hoursFull",
    defaultMessage: "hours",
  },
  duration: {
    id: "duration",
    defaultMessage: "Duration",
  },
  checkAvailability: {
    id: `checkAvailability`,
    defaultMessage: "Check availability",
  },
  planAdvance: {
    id: "planAdvance",
    defaultMessage: "You can plan up to 3 months in advance",
  },
  plan: {
    id: `plan`,
    defaultMessage: "Plan",
  },
  planDayPart: {
    id: `planDayPart`,
    defaultMessage: "Plan time slot",
  },
  planTreatment: {
    id: `planTreatment`,
    defaultMessage: "Plan appointment",
  },
  numberReFrezhNetherlands: {
    id: "numberRefrezhNetherlands",
    defaultMessage: "088 - 700 5588",
  },
  edit: {
    id: "edit",
    defaultMessage: "Edit",
  },
  remove: {
    id: "remove",
    defaultMessage: "Remove",
  },
  appointments: {
    id: "appointments",
    defaultMessage: "Appointments",
  },
  appointment: {
    id: "appointment",
    defaultMessage: "appointment",
  },
  timeSlot: {
    id: "timeSlot",
    defaultMessage: "Time slot",
  },
  agenda: {
    id: "Agenda",
    defaultMessage: "Agenda",
  },
  hoursSmall: {
    id: "hoursSmall",
    defaultMessage: "h",
  },
  minutesSmall: {
    id: "minutesSmall",
    defaultMessage: "min.",
  },
  changePassword: {
    id: "changePassword",
    defaultMessage: "Change password",
  },
  unavailable: {
    id: "Unavailable",
    defaultMessage: "Unavailable",
  },
  language: {
    id: "language",
    defaultMessage: "Language:",
  },
  navKey: {
    id: "navKey",
    defaultMessage: "navKey",
  },
  practiceNumber: {
    id: "practiceNumber",
    defaultMessage: "Practice Number",
  },
  practiceNumberShort: {
    id: "practiceNumberShort",
    defaultMessage: "Practice nr.",
  },

  customerNumber: {
    id: "customerNumber",
    defaultMessage: "Customer Number",
  },
  customerNumberShort: {
    id: "customerNumberShort",
    defaultMessage: "Customer nr.",
  },
  editAppointment: {
    id: "editAppointment",
    defaultMessage: "Edit appointment",
  },
  editTimeSlot: {
    id: "editTimeSlot",
    defaultMessage: "Edit time slot",
  },
  noPlannedTimeSlots: {
    id: "noPlannedTimeSlots",
    defaultMessage: "No planned timeslots",
  },
  notApplicableShort: {
    id: "notApplicable",
    defaultMessage: "n/a",
  },
  notYetPlanned: {
    id: "notYetPlanned",
    defaultMessage: "Not yet planned",
  },
  notKnownYet: {
    id: "notKnownYet",
    defaultMesage: "Not known yet",
  },
  dismiss: {
    id: "dismiss",
    defaultMessage: "dismiss",
  },
  patientName: {
    id: "patientName",
    defaultMessage: "Patient name",
  },
  patientNameColon: {
    id: "patientNameColon",
    defaultMessage: "Patient name: ",
  },
  insurer: {
    id: "insurer",
    defaultMessage: "Insurer",
  },
  insuranceNumber: {
    id: "insuranceNumber",
    defaultMessage: "Insurance number.",
  },
  insurance_number_colon: {
    id: "insurance_number_colon",
    defaultMessage: "Insurance number",
  },
  insurerColon: {
    id: "insurerColon",
    defaultMessage: "Insurer: ",
  },
  preparation: {
    id: "preparation",
    defaultMessage: "Preparation",
  },
  wrapUp: {
    id: "wrapUp",
    defaultMessage: "Wrap up",
  },
  selectTreatmentPlan: {
    id: "selectTreatmentPlan",
    defaultMessage: "Select treatment plan",
  },
  selectProductPlan: {
    id: "selectProductPlan",
    defaultMessage: "Select product plan",
  },

  cancelAppointments: {
    id: "cancelAppointments",
    defaultMessage: "Cancel all appointments to change the treatment plan",
  },
  bookTimeSlot: {
    id: "bookTimeSlot",
    defaultMessage: "Book time slot",
  },
  planAppointment: {
    id: "planAppointment",
    defaultMessage: "Plan appointment",
  },
  tooSoonPopUpHeader: {
    id: "tooSoonPopUpHeader",
    defaultMessage: "Contact ReFrezh by telephone",
  },
  rightToPlan: {
    id: "rightToPlan",
    defaultMessage: "Right to plan",
  },
  rightToOrder: {
    id: "rightToOrder",
    defaultMessage: "Right to order",
  },
  yesButtonText: {
    id: "yesButtonText",
    defaultMessage: "Yes",
  },
  noButtonText: {
    id: "noButtonText",
    defaultMessage: "No",
  },
  maybeButtonText: {
    id: "maybeButtonText",
    defaultMessage: "M",
  },
  orderUpperJaw: {
    id: "orderUpperJaw",
    defaultMessage: "Order Upper jaw",
  },
  orderLowerJaw: {
    id: "orderLowerJaw",
    defaultMessage: "Order Lower jaw",
  },
  productPlanUpperJaw: {
    id: "productPlanUpperJaw",
    defaultMessage: "Product plan upper jaw",
  },
  productPlanLowerJaw: {
    id: "productPlanLowerJaw",
    defaultMessage: "Product plan lower jaw",
  },
  deliveryDate: {
    id: "deliveryDate",
    defaultMessage: "Deliver date",
  },
  delivery: {
    id: "delivery",
    defaultMessage: "Delivery:",
  },

  no_delivery_date: {
    id: "no_delivery_date",
    defaultMessage: "No delivery date known",
  },
  practice: {
    id: "practice",
    defaultMessage: "Practice",
  },
  practiceEmail: {
    id: "practiceEmail",
    defaultMessage: "Practice Email",
  },
  downloadStlFiles: {
    id: "downloadStlFiles",
    defaultMessage: "Download STL-Files",
  },
  stlFiles: {
    id: "stlFiles",
    defaultMessage: "STL-Files",
  },
  physicBTI: {
    id: "physicBTI",
    defaultMessage: "Physical BTI",
  },
  downloaden: {
    id: "downloaden",
    defaultMessage: "Downloaden",
  },
  addedFiles: {
    id: "addedFiles",
    defaultMessage: "{fileCount} files added",
  },
  remakeReason: {
    id: "remakeReason",
    defaultMessage: "Reason(s) old AvaDent case nr. {oldCaseNo}",
  },
  remake: {
    id: "remake",
    defaultMessage: "Remake",
  },
  warranty: {
    id: "warranty",
    defaultMessage: "Warranty",
  },
  product: {
    id: "product",
    defaultMessage: "Product",
  },
  changes: {
    id: "changes",
    defaultMessage: "Make changes",
  },
  reorder: {
    id: "reorder",
    defaultMessage: "Reorder try-in / placement",
  },
  processedInClient: {
    id: "processedInClient",
    defaultMessage: "Processed in Client",
  },
  avaDentCaseNr: {
    id: "avaDentCaseNr",
    defaultMessage: "AvaDent case number",
  },
  avaDentCaseNrShort: {
    id: "avaDentCaseNrShort",
    defaultMessage: "AvaDent case no.",
  },

  upperCaps: {
    id: "upperCaps",
    defaultMessage: "UPPER",
  },

  lowerCaps: {
    id: "lowerCaps",
    defaultMessage: "LOWER",
  },
  alternativeFilesReceived: {
    id: "alternativeFilesReceived",
    defaultMessage: "Alternative files received",
  },
  treatmentPhase: {
    id: "treatmentPhase",
    defaultMessage: "Treatment phase",
  },
  tel_nr: {
    id: "tel_nr",
    defaultMessage: "Telephone number",
  },
  house_nr: {
    id: "house_nr",
    defaultMessage: "House number",
  },
  house_nr_extra: {
    id: "house_nr_extra",
    defaultMessage: "Additional",
  },
  homeTreatmentInfoTitle: {
    id: "homeTreatmentInfoTitle",
    defaultMessage: "Home treatment info",
  },
  gdsTreatmentInfo: {
    id: "gdsTreatmentInfo",
    defaultMessage: "GDS Treatment info",
  },
  dentistInfoTitle: {
    id: "dentistInfoTitle",
    defaultMessage: "Dentist info",
  },
  address: {
    id: "address",
    defaultMessage: "Address",
  },
  viewEditPatient: {
    id: "viewEditPatient",
    defaultMessage: "View / edit patient records",
  },
  dataNotSavedModalAppointmentTitle: {
    id: "dataNotSavedModalAppointmentTitle",
    defaultMessage: "BEWARE! THE CURRENT INFORMATION WILL NOT BE SAVED",
  },
  dataNotSavedModalAppointmentBody: {
    id: "dataNotSavedModalAppointmentBody",
    defaultMessage:
      "By going to the patient records you will leave the current process. The entered data will not be saved. Through the patient records you can book a new appointment.",
  },
  dataNotSavedModalOrderTitle: {
    id: "dataNotSavedModalOrderTitle",
    defaultMessage: "BEWARE: Order has not been placed yet!",
  },
  dataNotSavedModalOrderBody: {
    id: "dataNotSavedModalOrderBody",
    defaultMessage:
      'By navigating to the patient records you will leave the order process. Press "X" to return to the order. To continue to the patient records click "Continue"',
  },
  patientAdd: {
    id: "patientAdd",
    defaultMessage: "Add Patient",
  },
  patient: {
    id: "patient",
    defaultMessage: "Patient",
  },
  productUpper: {
    id: "productUpper",
    defaultMessage: "Product Upper",
  },
  productLower: {
    id: "productLower",
    defaultMessage: "Product Lower",
  },
  noDataText: {
    id: "noDataText",
    defaultMessage: "No results",
  },
  implantCount: {
    id: "implantCount",
    defaultMessage: "Number of implants",
  },
  scannersAvailable: {
    id: "scannersAvailable",
    defaultMessage: "Scanners available",
  },
  somethingWentWrong: {
    id: "somethingWentWrong",
    defaultMessage: "Something went wrong, please try again or contact ReFrezh... ",
  },
  withScanner: {
    id: "withScanner",
    defaultMessage: "With scanner",
  },
  previousOrderInformation: {
    id: "previousOrderInformation",
    defaultMessage: "Previous order",
  },
  gds: {
    id: "gds",
    defaultMessage: "GDS",
  },
  treatmentPlan: {
    id: "treatmentPlan",
    defaultMessage: "Treatmenplan",
  },
  productPlan: {
    id: "productPlan",
    defaultMessage: "Productplan",
  },
  driver: {
    id: "driver",
    defaultMessage: "Driver",
  },
});
